<template>
    <v-row justify="center">
        <v-dialog v-model="mostrar" persistent max-width="800px">
            <v-card>
                <v-card-title v-if="informe">
                    Muestreos de Lote: {{ informe.lote }}
                </v-card-title>
                <v-card-text>
                    <v-data-table
                        :items="muestreos"
                        :headers="encabezado"
                    >
                        <template v-slot:valor="{ item }">
                            <td>{{  `${item.simbolo != '=' ? item.simbolo : ''}${item.valor}` }}</td>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="blue darken-1" dark @click="cerrarModal">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mapState, mapMutations } from "vuex";
// import axios from 'axios'
export default {
    data: () => ({
        mostrar: false,
        informe: null,
        encabezado: [
            { text: 'Parámetro', value: 'parametro', class:"cabecera" },
            { text: 'Valor', value: 'valor', class:"cabecera" },
        ],
        muestreos: [],
    }),
    beforeDestroy() {
        Event.$off("abrir_modal_muestreos");
    },
    mounted() {
        Event.$on("abrir_modal_muestreos", (item, search_lote) => {
            this.informe = item;
            this.cargarMuestreo(search_lote);
        });
    },
    methods: {
        cargarMuestreo(search_lote = undefined) {
            this.mostrarLoading({ titulo: 'Obteniendo informes de muestreo...', color: 'green' });
            let url = `${this.base_url}informes_muestreos/${this.informe.id}`;
            
            if(search_lote) {
                url = url + `?search_lote=1`
            };

            this.axios.get(url, this.headers).then(res => {
                this.muestreos = res.data.data;
                this.ocultarLoading();
                this.mostrar = true;
            }).catch(error => {
                this.errorMessage(error);
                console.error(error, "Error al obtener datos de informe");
            });
        },
        cerrarModal() {
            this.mostrar = false;
        },
        ...mapMutations(["mostrarLoading", "ocultarLoading"]),
    },
    computed: {
        ...mapState(["base_url", "headers"]),
    },
};
</script>
